module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dZqVIJ/tc-custom/1.png?1688985128428?1725650247864",
      "alt": "This image is the cover for the book The Ghost Who Lived in the Cupboard"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Ghost Who Lived in the Cupboard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A touching story about Daniel, a boy who moves with his parents into a rambling and old country house. Aged ten, Daniel meets and becomes friends with Conrad, the resident thirteenth-century ghost, who lives in the walk-in wardrobe in Daniel's bedroom. As time passes, Daniel grows up but Conrad ages no further… Can their friendship survive the passage of time?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rita M. Hopkins\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rita is married with adult sons, grand-children, a dog called Talia and a bearded dragon lizard known as Ig. As well as being a writer, she is an avid reader too. Further interests include gardening, nature, crafts and sewing. She would love to learn brickwork and is fascinated by mini-diggers! Having initially been involved with primary education when her own sons were at school, she went on to work as a dinner-lady, managing out-of-hours clubs and working as a classroom assistant, predominantly supporting ethnic minority children with literacy and numeracy. At the tender age of 75 years, she is now fully retired and concentrating on writing for children.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0